import { FAIconName } from '@equip.health/ui';

import ConfirmModal from './ConfirmModal';

interface DiscardChangesModalV2Props {
  body?: string;
  cancelLabel?: string;
  confirmLabel?: string;
  id?: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
}

const DiscardChangesModalV2 = ({
  body = "You have changes that won't be saved.",
  cancelLabel = 'Return to editing',
  confirmLabel = 'Discard changes',
  id,
  isOpen,
  onClose,
  onConfirm,
  title = 'Discard unsaved changes?',
}: DiscardChangesModalV2Props) => (
  <ConfirmModal
    body={body}
    cancelIcon={FAIconName.arrowLeftRegular}
    cancelLabel={cancelLabel}
    confirmIcon={FAIconName.trashRegular}
    confirmLabel={confirmLabel}
    confirmVariant="accent.critical"
    id={id}
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onConfirm}
    title={title}
  />
);

export default DiscardChangesModalV2;
